/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/finance/plans/:action", {}, {
    getTable: {method: 'GET', params: {action: 'destinations'}}
})}];
